import { useThemeStore } from '@/stores'
import { scrollToSelector } from '@/utils'
import { BUNDLE_COLLECTION_ID, COFFEE_BUNDLE_COLLECTION_ID, COFFEE_BUNDLE_SKU } from '@/services/constants'
import BundleSummaryHalfSheet from '@/components/bundle/bundle-summary-half-sheet.vue'

import type {
  BundlePlan,
  BundleProduct,
  BundleProductVariant,
  BundleProductSelection,
  BundleType
} from '@/types/bundle'

import type {
  BundleAppProxy,
  BundleSelectionAppProxy
} from '@rechargeapps/storefront-client'

export const createBundleSelections = (selection: BundleProductSelection[], bundleType: BundleType) => {
  return selection
    .sort((a, b) => (a.product.title.localeCompare(b.product.title)))
    .sort((a, b) => (b.quantity - a.quantity))
    .map(({ key, quantity }) => {
      const [ externalProductId, externalVariantId ] = key.split('/')
      return {
        collectionId: bundleType === 'coffee' ? COFFEE_BUNDLE_COLLECTION_ID : BUNDLE_COLLECTION_ID,
        externalProductId,
        externalVariantId,
        quantity
      } as BundleSelectionAppProxy
    })
}

export const createBundleSelection = (product: BundleProduct, variant: BundleProductVariant, selection: BundleProductSelection[]): BundleAppProxy => {
  const bundleType = COFFEE_BUNDLE_SKU.test(variant.sku) ? 'coffee' : 'oatmeal'
  return {
    externalProductId: String(product.nid),
    externalVariantId: String(variant.nid),
    selections: createBundleSelections(selection, bundleType)
  }
}

export const sortBundleProductSelections = (selection: BundleProductSelection[]) => {
  return [ ...selection ]
    .sort((a, b) => (a.product.title.localeCompare(b.product.title)))
    .sort((a, b) => (b.quantity - a.quantity))
}

export const getBundleSellingPlanId = (product: BundleProduct, plan: BundlePlan) => {
  if (plan === 'onetime') {
    return
  }

  const sellingPlan = product.sellingPlans?.find(i => i.recurringDeliveries)
  return sellingPlan?.nid
}

export const bundleJSONContents = (selection: BundleProductSelection[]) => {
  return selection.map(item => {
    const { quantity, product: { title, sku } } = item
    return { quantity, title, sku }
  })
}

export const clampToRemainingSlots = (value: number, currentQty: number, totalQty: number, maxSize: number) => {
  const remainingSlots = maxSize - totalQty + currentQty
  return Math.min(value, remainingSlots)
}

export const showBundleSummary = () => {
  const { sheet } = useThemeStore()
  const $el: HTMLElement | null = document.querySelector('.sidebar .bundle-summary')
  if ($el?.offsetParent) {
    scrollToSelector('.product-scroll-container', 17)
    highlightBundleSummary()
  } else if (!sheet.visible) {
    sheet.open(BundleSummaryHalfSheet)
  }
}

const highlightBundleSummary = () => {
  const summary = document.querySelector('.bundle-summary')
  if (summary) {
    summary.classList.add('highlight')
    setTimeout(() => {
      summary.classList.remove('highlight')
    }, 1000)
  }
}
